/* Shared clearance state and navigation helpers; no purchase/add_to_cart events are emitted here. */
(() => {
  'use strict';
  const node = document.getElementById('fb-campaign-config');
  if (!node) return;
  let config; try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const active = config.active === true;
 function setupSubnav(root) {
  root.querySelectorAll('[data-fb-subnav]').forEach(nav => {
   if (nav.dataset.fbInitialized) return;
   nav.dataset.fbInitialized = 'true';
   const track = nav.querySelector('[data-fb-subnav-track]'), next = nav.querySelector('[data-fb-subnav-next]');
   if (!track || !next) return;
   const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    next.hidden = max < 2;
    const atEnd = track.scrollLeft >= max - 2;
    next.setAttribute('aria-label',atEnd ? 'Wróć do pierwszych podkategorii' : 'Pokaż więcej podkategorii');
    next.dataset.atEnd = String(atEnd);
   };
   next.addEventListener('click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (next.dataset.atEnd === 'true') track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
    else track.scrollBy({ left: Math.max(160, track.clientWidth * .75), behavior: reduce ? 'auto' : 'smooth' });
   });
   track.addEventListener('scroll',update,{passive:true});
   if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
   else window.addEventListener('resize',update,{passive:true});
   update();
  });
 }
  const api = {
    active,
    money(cents, moneyFormat) {
      const currency = window.Shopify?.currency?.active || config.currency;
      // Intl uses the active Shopify presentment currency and supports Markets.
      try { return new Intl.NumberFormat(config.locale || 'en', {style:'currency',currency}).format(Number(cents) / 100); }
      catch (_) { return window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents, moneyFormat || config.moneyFormat) : (Number(cents)/100).toFixed(2) + ' ' + currency; }
    },
    scan(scope = document) {
      if (!api.active) { scope.querySelectorAll('[data-fb-campaign]').forEach(el => { el.hidden = true; }); return; }
      setupSubnav(scope);
      scope.querySelectorAll('.fb-vip-banner,#fb-vip-banner,.fb-vip-mobile-cta').forEach(el=>el.remove());
      scope.querySelectorAll('.article-content a,.page__content a').forEach(link=>{
        if (/joy-loyalty-page|vip-membership/i.test(link.getAttribute('href')||'') && link.querySelector('img')) link.remove();
      });
    }
  };
  window.FansBrandsCampaign = api;
  document.documentElement.dataset.fbCurrency = config.currency;
  document.documentElement.dataset.fbClearance = String(active);
  const boot = () => {
    api.scan();
    // Quick Add and Shopify section responses may arrive after initial load.
    const observer = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(added => {
        if (added.nodeType === 1 && (added.matches('[data-fb-subnav]') || added.querySelector('[data-fb-subnav]'))) {
          api.scan(added);
        }
      }));
    });
    observer.observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load',event=>api.scan(event.target));
    // Optional, distinct campaign engagement events. Existing ecommerce tracking is untouched.
    document.addEventListener('click',event=>{
      const link=event.target.closest('[data-fb-campaign-event]');
      if(link && api.active && Array.isArray(window.dataLayer)) window.dataLayer.push({event:link.dataset.fbCampaignEvent,link_url:link.getAttribute('href'),link_text:link.textContent.trim()});
    });
    document.addEventListener('toggle',event=>{
      const details=event.target;
      if(details.matches && details.matches('.fb-ux-accordion--vip') && details.open && api.active && Array.isArray(window.dataLayer)) window.dataLayer.push({event:'clearance_vip_info_open'});
    },true);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
